import type { Nullable } from 'corgi-types';

import type { Translate } from 'common/providers/LocaleProvider';

export const getAdditionalInfoEditLabel = ({
  t,
  vendorOrderId,
  partNumbers,
  pictureCount,
}: {
  t: Translate;
  vendorOrderId: Nullable<string>;
  partNumbers: string[];
  pictureCount: number;
}) => {
  const parts = [
    vendorOrderId && `${t('h24_rauch_number_title')}: ${vendorOrderId}`,
    partNumbers.length && `${t('h24_part_numbers')}: ${partNumbers.join(', ')}`,
    pictureCount > 0 && `${t('h24_images_attached')} (${pictureCount})`,
  ].filter(Boolean);

  return `${t('h24_edit_additional_info')}: ${parts.join(', ')}`;
};
